import {Component, Inject, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import { DataService } from "../../data.service";
import { isString } from 'util';

@Component({
  selector: 'app-tawk-to',
  templateUrl: './tawk-to.component.html',
  styleUrls: ['./tawk-to.component.scss']
})
export class TawkToComponent implements OnInit {

  script = this._renderer.createElement('script');

  constructor(
    private _renderer: Renderer2, 
    @Inject(DOCUMENT) private _document, 
    public dataService: DataService) {}

  ngOnInit() {
    let script_src;
    if( !!this.dataService.tawkto_url ){
      const lng = this.dataService.get_language();
      try {
        if( isString( this.dataService.tawkto_url) ){
          script_src = this.dataService.tawkto_url;
        } else {
          script_src = this.dataService.tawkto_url[lng.toLowerCase()];
        } 
      } catch(e){};
    }
    if( !!script_src ){
      this.script.text = `var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
      (function () {
        var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = '${script_src}';
        s1.charset = 'UTF-8';
        s1.setAttribute('crossorigin', '*');
        s0.parentNode.insertBefore(s1, s0);
      })();`;
      this._renderer.appendChild(this._document.body, this.script);
    }
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/tawk-to/tawk-to.component.ts